import { trainingCollaboratorApi, type TrainingCollaboratorListItem } from '@/entities/Training';

const COLLABORATORS_ITEMS_PER_PAGE = 100;

export async function fetchAllTrainingCollaborators(
  trainingId: number
): Promise<TrainingCollaboratorListItem[]> {
  const first = await trainingCollaboratorApi.listTrainingCollaborators(trainingId, {
    page: 1,
    itemsPerPage: COLLABORATORS_ITEMS_PER_PAGE,
    sort: 'name',
    order: 'asc',
  });
  const collected = [...first.data];
  const totalPages = first.metadata.totalPages ?? 1;

  for (let page = 2; page <= totalPages; page += 1) {
    const result = await trainingCollaboratorApi.listTrainingCollaborators(trainingId, {
      page,
      itemsPerPage: COLLABORATORS_ITEMS_PER_PAGE,
      sort: 'name',
      order: 'asc',
    });
    collected.push(...result.data);
  }

  return collected;
}
